/** 浏览器版本校验 */
export function check() {
  const div = document.createElement('div');
  div.style = `text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3333;
    background: #FFF;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    `;
  const div_1 = document.createElement('div');
  const div_2 = document.createElement('div');
  div.appendChild(div_1);
  div.appendChild(div_2);

  div_1.textContent = '浏览器版本检测中 ...';
  div_1.style = `margin-bottom: 15px;`;
  div_2.textContent = navigator.userAgent;
  document.body.appendChild(div);
  try {
    let supported = true;
    const missingFeatures: string[] = [];

    // 1. 检测 Object.hasOwn
    if (typeof Object.hasOwn !== 'function') {
      supported = false;
      missingFeatures.push('Object.hasOwn');
    }

    // 2. 检测 Array.prototype.at
    if (typeof Array.prototype.at !== 'function') {
      supported = false;
      missingFeatures.push('Array.prototype.at');
    }

    // 3. 检测 String.prototype.at
    if (typeof String.prototype.at !== 'function') {
      supported = false;
      missingFeatures.push('String.prototype.at');
    }

    // 检测 Map.prototype.forEach
    if (typeof Map.prototype.forEach !== 'function') {
      supported = false;
      missingFeatures.push('Map.prototype.forEach');
    }
    // 4 检测是否支持 structuredClone
    if (typeof globalThis.structuredClone !== 'function') {
      supported = false;
      missingFeatures.push('globalThis.structuredClone');
    }

    // 5. 检测私有类字段（Private Class Fields）
    try {
      // 动态构造函数（避免构建时语法报错）
      const code = `
      class Test {
        #privateField = 'ok';
        getPrivate() { return this.#privateField; }
      }
      return new Test().getPrivate() === 'ok';
    `;
      // 使用 Function 构造器绕过静态语法检查（仅在运行时执行）
      const testPrivateField = new Function(code);
      if (!testPrivateField()) {
        supported = false;
        missingFeatures.push('Private class fields');
      }
    } catch (e) {
      supported = false;
      missingFeatures.push('Private class fields');
    }

    // supported = false;
    if (!supported) {
      location.replace('/browser-tips.html');
      // 抛出错误，阻止后续 JS 执行
      throw new Error(
        'ES2022 browser support required: ' + missingFeatures.join(', ')
      );
    }
  } finally {
    div.remove();
  }
}
